import { render } from "./previewEXhibitionManage.vue?vue&type=template&id=8803fad8"
import script from "./previewEXhibitionManage.vue?vue&type=script&setup=true&lang=js"
export * from "./previewEXhibitionManage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/components/previewEXhibitionManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8803fad8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8803fad8', __exports__)) {
    console.log('reload')
    api.reload('8803fad8', __exports__)
  }
  
  module.hot.accept("./previewEXhibitionManage.vue?vue&type=template&id=8803fad8", () => {
    console.log('re-render')
    api.rerender('8803fad8', render)
  })

}


export default __exports__